var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns mx-0 my-0"},[_c('div',{staticClass:"column notify has-text-centered has-background-black has-text-white"},[_c('p',{staticClass:"notify-text"},[_vm._v(_vm._s(_vm.notification))])])])}
var staticRenderFns = []

export { render, staticRenderFns }